var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.auth.isLogged)?_c('div',[_c('button',{staticClass:"button back",on:{"click":_vm.gotoadmin}},[_c('b-icon',{staticClass:"queueicon",attrs:{"pack":"fas","icon":"chevron-left","size":"is-small"}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5b2e384","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/backToAdmin.vue
// module id = null
// module chunks = 